export default __webpack_public_path__ + "static/media/learose5-1920w.b13bbda1.avif";